import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Clear from '@material-ui/icons/Clear';
import RejectGochiDialog from '../molecules/RejectGochiDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openRejectGochi', 'updateOpenRejectGochi', false)
);

const button = enhance(
  ({
    classes,
    openRejectGochi,
    updateOpenRejectGochi,
    params,
    onClickAction
  }) => {
    const cancelAction = () => updateOpenRejectGochi(false);
    const rejectAction = param => {
      updateOpenRejectGochi(false);
      onClickAction(param);
    };
    return (
      <div>
        <Button color="primary" onClick={() => updateOpenRejectGochi(true)}>
          <Clear className={classes.leftIcon} />
          ごち拒否
        </Button>
        <RejectGochiDialog
          openRejectGochi={openRejectGochi}
          updateOpenRejectGochi={updateOpenRejectGochi}
          cancelAction={cancelAction}
          rejectAction={() => rejectAction(params)}
          target="メニュー"
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
